import React, { FunctionComponent } from 'react';
import { Input, ErrorMessage } from 'react-design-components';
import FormComponentProps from '../FormComponentProps';
import usePhoneInput from './hooks/usePhoneInput';

interface FormData {
  phone?: string;
}

interface Props extends FormComponentProps<FormData> {
  withRequiredValidation?: boolean;
}

const PhoneInput: FunctionComponent<Props> = ({ t, register, errors, withRequiredValidation }) => {
  const { rules, labelProps, phone, onPhoneChange } = usePhoneInput(t, withRequiredValidation);
  return (
    <>
      <Input
        inputProps={register('phone', rules)}
        id="phone"
        type="text"
        value={phone}
        label={t('phone')}
        error={!!errors.phone}
        InputLabelProps={labelProps}
        onChange={onPhoneChange}
      />
      {!!errors.phone && <ErrorMessage>{errors.phone.message}</ErrorMessage>}
    </>
  );
};

export default PhoneInput;
